import { api } from './api';
import { DealInsights } from 'Models/deal-insights';
import { DealInsightsResult } from 'Models/deal-insights-result';

export const dealInsightsApi = api.injectEndpoints({
  endpoints: (build) => ({

    getDealInsights: build.mutation<
      DealInsightsResult,
      { companyId: string; params: DealInsights }
    >({
      query({ companyId, params }) {
        return {
          url: `integration/core/company/${companyId}/insights/deals`,
          method: 'POST',
          body: params,
        };
      },
      invalidatesTags: ['DealInsights'],
    }),
  }),
});

export const {
  useGetDealInsightsMutation} = dealInsightsApi;